import React from "react";
import { IMatrixPriorityItem } from "./interface";
import * as Matrix from "./styles";
import ListOfCardMatrix from "../Card/listOfCard";

const MatrixItem: React.FC<IMatrixPriorityItem> = ({
	number,
	color,
	data,
	titles
}) => (
	<>
		<Matrix.WrapQuadrant>
			<Matrix.WrapTitle color={color}>
				<Matrix.WrapTitleNumber>
					<span>{number}</span>
				</Matrix.WrapTitleNumber>
				<Matrix.WrapTitleQuadrant>
					<span>{titles.title1}</span>
					<Matrix.TitleDivisor/>
					<span>{titles.title2}</span>
				</Matrix.WrapTitleQuadrant>
			</Matrix.WrapTitle>
			<Matrix.WrapPanel>
				<Matrix.PanelHeading>
					{titles.heading}
				</Matrix.PanelHeading>
				<Matrix.PanelContent>
					<ListOfCardMatrix 
						data={data}
						number={number}
						numberOfElements={5}
					/>
				</Matrix.PanelContent>
			</Matrix.WrapPanel>
		</Matrix.WrapQuadrant>
	</>
);

export default MatrixItem;
